module.exports = __webpack_public_path__ + "img/master_kg.26588ff3.jpg";